import { SiteDetails } from '@frontend/wam-views';
import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  const { siteName } = Route.useParams() as { siteName: string };

  return (
    <Page
      title={`Site: ${siteName}`}
      breadcrumbs={[
        {
          label: 'Global Settings',
          to: '/global-settings',
        },
        {
          label: 'Web Releases',
          to: '/global-settings/releases',
        },
        {
          label: siteName,
        },
      ]}
    >
      <Container>
        <SiteDetails site={siteName} />
      </Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/global-settings/releases_/$siteName',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
